"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var ApiService_1 = require("CreatePageFlow/ApiService");
var BemBuilder_1 = __importDefault(require("../../Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var utils_1 = require("../utils");
var types_1 = require("CreatePageFlow/types");
var BouncingQwilrLogo_1 = __importDefault(require("CreatePageFlow/CreatePageComponents/BouncingQwilrLogo"));
var c = (0, BemBuilder_1.default)("create-page-flow-preload");
var PreLoad = (function (_super) {
    __extends(PreLoad, _super);
    function PreLoad() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMessage = null;
        _this.isLoading = false;
        return _this;
    }
    PreLoad.prototype.setErrorMessage = function (errorMessage) {
        this.errorMessage = errorMessage;
    };
    PreLoad.prototype.setIsLoading = function (isLoading) {
        this.isLoading = isLoading;
    };
    PreLoad.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, store, moveStep, flowSource, template, e_1, templateList, e_2, _b, _c, e_3;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, store = _a.store, moveStep = _a.moveStep, flowSource = _a.flowSource;
                        this.setIsLoading(true);
                        if (!(flowSource === types_1.CreatePageFlowSource.Qwilr && store.templateId)) return [3, 5];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4, this.apiService.getTemplate(store.templateId)];
                    case 2:
                        template = _d.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _d.sent();
                        this.setIsLoading(false);
                        this.setErrorMessage(utils_1.GENERIC_ERROR);
                        return [2];
                    case 4:
                        store.setTemplate(template);
                        if (template.crmInfo.connected && template.crmInfo.integration) {
                            store.setIntegrationName(template.crmInfo.integration);
                        }
                        return [3, 11];
                    case 5:
                        if (!(flowSource === types_1.CreatePageFlowSource.Crm && store.integrationName && store.objectType)) return [3, 10];
                        _d.label = 6;
                    case 6:
                        _d.trys.push([6, 8, , 9]);
                        return [4, this.apiService.getCRMTemplates(store.objectType, store.integrationName)];
                    case 7:
                        templateList = _d.sent();
                        templateList.sort(function (a, b) {
                            return new Date(b.lastEditedAt).toISOString().localeCompare(new Date(a.lastEditedAt).toISOString());
                        });
                        store.setTemplateList(templateList);
                        return [3, 9];
                    case 8:
                        e_2 = _d.sent();
                        this.setIsLoading(false);
                        this.setErrorMessage(utils_1.GENERIC_ERROR);
                        return [2];
                    case 9: return [3, 11];
                    case 10: throw new Error("Unexpected input data");
                    case 11:
                        if (!(store.integrationName && (0, utils_1.isPlatformSupportedIntegration)(store.integrationName))) return [3, 15];
                        _d.label = 12;
                    case 12:
                        _d.trys.push([12, 14, , 15]);
                        _c = (_b = store).setIntegrationState;
                        return [4, this.apiService.verifyIntegration(store.integrationName)];
                    case 13:
                        _c.apply(_b, [_d.sent()]);
                        return [3, 15];
                    case 14:
                        e_3 = _d.sent();
                        this.setIsLoading(false);
                        this.setErrorMessage(utils_1.GENERIC_ERROR);
                        return [2];
                    case 15:
                        this.setIsLoading(false);
                        moveStep(1);
                        return [2];
                }
            });
        });
    };
    PreLoad.prototype.render = function () {
        var flowSource = this.props.flowSource;
        if (flowSource === types_1.CreatePageFlowSource.Qwilr) {
            return (react_1.default.createElement("div", { className: c() },
                this.isLoading && react_1.default.createElement(kaleidoscope_1.Spinner, { className: c("spinner"), size: kaleidoscope_1.SpinnerSize.Large, primary: true }),
                !this.isLoading && this.errorMessage && (react_1.default.createElement(kaleidoscope_1.Alert, { className: c("error"), alertType: kaleidoscope_1.AlertType.Error, heading: "Error" }, this.errorMessage))));
        }
        else if (flowSource === types_1.CreatePageFlowSource.Crm) {
            return (react_1.default.createElement("div", { className: c() },
                react_1.default.createElement("div", { className: "space-stack-m" },
                    react_1.default.createElement(BouncingQwilrLogo_1.default, null)),
                react_1.default.createElement("div", { className: "space-stack-l" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "5" }, "Getting things ready...")),
                this.errorMessage && (react_1.default.createElement(kaleidoscope_1.Alert, { className: c("error"), alertType: kaleidoscope_1.AlertType.Error, heading: "Error" }, this.errorMessage))));
        }
        else {
            return null;
        }
    };
    var _a;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof ApiService_1.ApiService !== "undefined" && ApiService_1.ApiService) === "function" ? _a : Object)
    ], PreLoad.prototype, "apiService", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], PreLoad.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PreLoad.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PreLoad.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PreLoad.prototype, "setIsLoading", null);
    PreLoad = __decorate([
        mobx_react_1.observer
    ], PreLoad);
    return PreLoad;
}(react_1.default.Component));
exports.default = PreLoad;
